import * as React from "react";
import Conversation from "../../_data/models/Conversation";
import ConversationContainer from "../containers/ConversationContainer";
import ReduxInfiniteScroll from "redux-infinite-scroll";
import Meta from "../../_data/models/Meta";
import LoadingIndicatorComponent from "../../_widgets/loadingIndicator/LoadingIndicatorComponent";

interface Props {
    conversations: Conversation[];
    meta: Meta;
    loadMore: (meta: Meta) => void;
    loading: boolean;
}

const ConversationsComponent = (props: Props) => {
    const {conversations, loadMore, meta, loading} = props;

    return (
        <div className="row">
            <div className="row expanded">
                <div className="medium-6 column">
                    <nav aria-label="You are here:" role="navigation" className="mt-1 mb-1">
                        <ul className="breadcrumbs">
                            <li>All Messages</li>
                        </ul>
                    </nav>
                </div>
                <div className="medium-6 column">
                    <div className="search-box mt-half mb-half">
                        <div className="pull-right search-box">
                            {/* <input type="text" placeholder="Search" required> */}
                            {/*<a data-open="composemessage" className="button small mb-0 hollow">*/}
                            {/*<i className="fa fa-pencil fa-fw mr-half" aria-hidden="true"/>Compose Message*/}
                            {/*</a>*/}
                        </div>
                    </div>
                </div>
            </div>

            <div className="row expanded">
                <div className="medium-12 column">
                    <div className="panel">
                        <table className="single-line">
                            <thead>
                            <tr>
                                <th>From: / To:</th>
                                <th>Message</th>
                                <th>Date Received</th>
                            </tr>
                            </thead>
                            <ReduxInfiniteScroll
                                holderType="tbody"
                                loadMore={() => loadMore(meta)}
                                elementIsScrollable={false}
                                loadingMore={loading}
                                loader={<tr><td colSpan={3}><LoadingIndicatorComponent/></td></tr>}
                                threshold={200}>
                                {
                                    conversations.map(c => {
                                        return <ConversationContainer conversation={c} key={c.id}/>
                                    })
                                }
                            </ReduxInfiniteScroll>
                        </table>
                        {/*<ul className="pagination" role="navigation" aria-label="Pagination">*/}
                            {/*<li className="pagination-previous disabled">Previous <span*/}
                                {/*className="show-for-sr">page</span>*/}
                            {/*</li>*/}
                            {/*<li className="current"><span className="show-for-sr">You're on page</span> 1</li>*/}
                            {/*<li><a href="#" aria-label="Page 2">2</a></li>*/}
                            {/*<li><a href="#" aria-label="Page 3">3</a></li>*/}
                            {/*<li><a href="#" aria-label="Page 4">4</a></li>*/}
                            {/*<li className="ellipsis" aria-hidden="true"/>*/}
                            {/*<li><a href="#" aria-label="Page 12">12</a></li>*/}
                            {/*<li><a href="#" aria-label="Page 13">13</a></li>*/}
                            {/*<li className="pagination-next"><a href="#" aria-label="Next page">Next <span*/}
                                {/*className="show-for-sr">page</span></a></li>*/}
                        {/*</ul>*/}
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ConversationsComponent;


// WEBPACK FOOTER //
// ./app/client/message/components/ConversationsComponent.tsx